import "./PopularGetaways.module.css";
import Header from "@/reusable_sections/Header";
import TravelHighlights from "./sections/TravelHighlights";
import Footer from "@/reusable_sections/Footer";
export default function PopularGetawaysPage() {
  return <div>
      <Header />
      <TravelHighlights />
      <Footer />
    </div>;
}